import axios from 'axios'
import qs from 'qs'
import config from '../config.js'
import apicode from './apicode.js'
import { Message } from 'element-ui';
import { showFullScreenLoading, tryHideFullScreenLoading } from "./serviceLoading.js";
import router from '../router'

if (process.env.NODE_ENV === 'production' && API_HOST) {
  axios.defaults.baseURL = API_HOST
} else {
  axios.defaults.baseURL = config.api_host
}
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

axios.interceptors.request.use(config => {

  config.headers.noLoading || showFullScreenLoading();

  let access_token = localStorage.getItem('access_token')

  if (access_token) {
    config.headers.authorization = "Bearer " + access_token
  }
  if (config.method === 'post') config.data = qs.stringify(config.data)
  return config
}, error => {
  // Promise.reject (error)
})

export default function (options) {

  let method, request_options, url, headers = {}

  if (typeof options !== 'object' || typeof options.url !== 'string') {
    Message.error('接口方法调用错误')
    return false
  }

  method = typeof options.method !== 'undefined' ? options.method : 'post'
  url = options.url

  if (typeof options.headers === 'object') {
    headers = options.headers
  }
  if (options.data instanceof FormData) {

    let jsonData = {}

    options.data.forEach((v, k) => jsonData[k] = v)

    options.data = jsonData
  }

  switch (method) {
    case 'get':
      request_options = { params: typeof options.data === 'object' ? options.data : {} }
      break
    default:
      request_options = typeof options.data === 'object' ? options.data : {}
  }

  let login_type = localStorage.getItem('login_type')

  if (login_type && typeof request_options.type === 'undefined') request_options.type = login_type

  for (let o in request_options) {

    if (url.indexOf(':' + o) !== -1) {

      url = url.replace(':' + o, request_options[o])
      delete request_options[o]
    }
  }

  return new Promise((resolve, reject) => {
    axios[method].call(this, url, request_options, headers).then((res) => {

      let status = res.data.meta.status = res.data.meta.status + ''
      if (status !== '10000') {
        let msg = typeof apicode[status] !== 'undefined' ? apicode[status] : ''

        //账号类型不符
        if(status=='29204'){
          Message.error(apicode[status])
          localStorage.removeItem('loginType')
          localStorage.removeItem('access_token')
          router.push({ path: '/login' })
        }else if (typeof apicode[status] !== 'undefined') {
          Message.error(apicode[status])
        } else {
          switch (status) {
            case '10400':
            case '10405':
            case '10500':
              Message.error('接口请求错误:' + status)
              break
            default:
              reject(res.data, msg)
            // return options.error instanceof Function && options.error.call (this, res, msg)
          }
        }
      } else {
        resolve(res.data);
        // return options.success.call (this, res)
      }
      tryHideFullScreenLoading();
    }).catch((error) => {
      // TODO 处理http異常狀態碼 如500
      tryHideFullScreenLoading();
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/http/request.js